import { type FunctionComponent } from "react";

type LabelProps = {
  htmlFor: string;
  text: string;
};

export const Label: FunctionComponent<LabelProps> = ({ htmlFor, text }: LabelProps) => {
  return (
    <label htmlFor={htmlFor} className="font-bold">
      {text}
    </label>
  );
};
